var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`product-badges ${_vm.position}`},[(_vm.isLongTermProduction)?_c('span',{staticClass:"product-badges__long-terms"},[_vm._v(" Длительное производство ")]):_vm._e(),(_vm.isLimitedSeries)?_c('span',{staticClass:"product-badges__limited"},[_vm._v(" Количество товара ограничено ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }